import { Component } from '@angular/core';

@Component({
    template: `<button refreshSession type="buttton">Prueba</button>`
  })

  export class RefreshComponent {
  }
